module.exports = __webpack_public_path__ + "img/final_1.41371da8.png";